import React from 'react';

const PunchListItem = ({
  itemText,
  isMVP = true,
  isBlocked = false,
  isBug = false,
  completeDate = ''
}) => {
  
  const itemStyle = isBug 
    ? { color:'#bd0c3c', fontSize: '1rem', fontWeight:600, margin: '0 0 1.5rem' }
    : { color:'#45820c', fontSize: '1rem', fontWeight:600, margin: '0 0 1.5rem' }

  return (
    <li style={itemStyle}>
      {isMVP && (' [MVP] ')}
      {isBlocked && (' [Blocked] ')}
      {isBug && (' [Bug] ')}
      {itemText}
      {completeDate
        ? <span style={{color: 'purple'}}> [complete: {completeDate}]</span>
        : <span style={{color: '#000'}}> [in queue]</span>
      }
    </li>
  );  
}

export default PunchListItem